module.exports = __webpack_public_path__ + "img/outofoffice.c6ab12ef.png";